import { AccordionOverrides, SharedProps } from 'baseui/accordion';
import { Icons } from '../../ui/icons';
import { iconSetProps } from './accordion-props.interface';
import React from 'react';

const accordionOverride = (
  iconSet?: iconSetProps,
  externalOverrides?: AccordionOverrides<SharedProps>
) => {
  return {
    ...(externalOverrides || {}),
    ToggleIcon: {
      component: ({ $expanded }: SharedProps) =>
        iconSet ? (
          <Icons
            {...(iconSet?.fillColor && { fillColor: iconSet?.fillColor })}
            {...(iconSet?.iconWidth && { iconWidth: iconSet?.iconWidth })}
            {...(iconSet?.iconHeight && { iconHeight: iconSet?.iconHeight })}
            icon={$expanded ? iconSet?.upwards : iconSet?.downwards}
          />
        ) : null,
    },
  };
};

export default accordionOverride;
